import SiggerPrivacyPolicy from '../components/paneles/SiggerPrivacyPolicy';
import Footer from '../components/Footer';
import '../App.css';
import { ServiceEnums } from '../enums/ServicesEnum';

export default function PanelesPrivacyPolicy(){
    return (
        <>
            <SiggerPrivacyPolicy />
            <div className='information-section'>
                <Footer isPolicy={true} origin={ServiceEnums.SIGGER}/>  
            </div>     
        </>
    )
}